<template>
  <div class="w-100">
    <div
      v-loading="isLoading"
      element-loading-text="Đang chuẩn bị dữ liệu..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="#f5f5f5">
      <div class="d-flex align-items-start m-2">
        <el-select
          filterable
          v-model="selectedAccount"
          placeholder="Tìm kiếm tài khoản zalo..."
          size="sm"
          class="flex-1"
          style="max-width: 450px"
          multiple>
          <el-option
            v-for="account in accounts"
            :key="account.accountId"
            :label="getAccountName(account)"
            :value="account.accountId"></el-option>
        </el-select>
        <el-select
          v-model="selectedEm"
          filterable
          placeholder="Tìm kiếm tài khoản nhân viên..."
          size="sm"
          class="flex-1 mx-2"
          style="max-width: 450px"
          multiple>
          <el-option
            v-for="em in employees"
            :key="em.username"
            :label="em.username"
            :value="em.username"></el-option>
        </el-select>
        <el-select
          v-model="selectedTagIds"
          filterable
          placeholder="Lọc theo tag"
          size="sm"
          style="max-width: 450px"
          class="flex-1"
          multiple>
          <el-option
            v-for="tag in app.tags"
            :key="tag.id"
            :label="getTagName(tag)"
            :value="tag.id"></el-option>
        </el-select>
        <el-select
          v-model="selectType"
          class="mx-2">
          <el-option
            v-for="item in types"
            :key="item.val"
            :label="item.name"
            :value="item.val"></el-option>
        </el-select>
        <div class="mx-2">
          <DateRangePicker
            size="sm"
            ref="picker"
            opens="left"
            :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy', applyLabel: 'Áp dụng', cancelLabel: 'Hủy' }"
            :minDate="'2019/01/01'"
            :singleDatePicker="false"
            :ranges="false"
            :showWeekNumbers="true"
            :showDropdowns="true"
            :autoApply="false"
            v-model="dateRange"
            :linkedCalendars="true">
            <template v-slot:input="picker">
              <span style="line-height: 25px; padding: 0 10px">
                Từ
                <b>{{ picker.startDate.toLocaleDateString("vi") }}</b>
                &nbsp; &nbsp; Đến
                <b>{{ picker.endDate.toLocaleDateString("vi") }}</b>
              </span>
            </template>
          </DateRangePicker>
        </div>
        <div>
          <el-button
            size="medium"
            @click="fetchStatistic()"
            type="primary">
            Tổng hợp
          </el-button>
        </div>
      </div>
      <el-card
        class="m-2"
        v-if="slider.interval < 100">
        <vue-slide-bar
          :speed="0.05"
          v-model="slider.interval"
          :showTooltip="false"
          :lineHeight="10"
          style="padding-top: 4px !important"
          :isDisabled="true" />
        <div class="mt-2 font-size-14">Đang tải dữ liệu {{ slider.interval }} %</div>
      </el-card>
      <div
        style="overflow-y: auto; max-height: calc(100vh - 160px); min-height: calc(100vh - 160px)"
        class="small-scrollbar">
        <el-tabs tab-position="left">
          <el-tab-pane>
            <div
              slot="label"
              class="text-start"
              style="width: 146px">
              Tỷ lệ theo hội thoại
            </div>
            <el-card
              class="flex-1"
              style="height: calc(100vh - 180px)">
              <!--              <div class="font-size-16 fw-semibold mb-1">Tỷ lệ theo hội thoại</div>-->
              <apexchart
                v-if="isReadyRender"
                type="pie"
                height="480"
                :options="chartOptions_a"
                :series="seriesA"></apexchart>
            </el-card>
          </el-tab-pane>
          <el-tab-pane>
            <div
              slot="label"
              class="text-start">
              Tỷ lệ theo tin nhắn
            </div>
            <el-card
              class="flex-1"
              style="height: calc(100vh - 180px)">
              <!--              <div class="font-size-16 fw-semibold mb-1">Tỷ lệ theo tin nhắn</div>-->
              <apexchart
                v-if="isReadyRender"
                type="pie"
                height="480"
                :options="chartOptions_b"
                :series="seriesB"></apexchart>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="Báo cáo theo tài khoản">
            <div
              slot="label"
              class="text-start"
              style="width: 146px">
              Báo cáo theo tài khoản
            </div>

            <el-card class="flex-1">
              <el-table
                :data="seriesAccount"
                max-height="600px"
                style="min-height: 470px"
                ref="elTable">
                <el-table-column
                  prop="employee"
                  label="Tài khoản">
                  <template slot-scope="scope">
                    <span class="fw-semibold">{{ scope.row.employee }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="totalConversation"
                  label="Hội thoại"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.totalConversation }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Đã gửi"
                  align="center"
                  prop="sent">
                  <template slot-scope="scope">
                    <span>{{ scope.row.sent }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="item in friendRequestTypeList"
                  :key="item.val"
                  :prop="item.val"
                  :label="item.name"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row[item.val] || 0 }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <div class="d-flex justify-content-end mt-3" v-if="seriesAccount.length > 0">
                <el-button plain type="primary" size="small" @click="exportToXLSXSeriesAccount" class="d-flex align-items-center">
                  <span>Xuất dữ liệu</span>
                  <span class="icon-download mx-1" />
                </el-button>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="Báo cáo từ khóa cấm">
            <div
              slot="label"
              class="text-start"
              style="width: 146px">
              Báo cáo từ khóa cấm
            </div>
            <el-card class="flex-1">
              <el-table
                :data="badWords"
                max-height="600px"
                style="min-height: 470px"
                ref="badWordTable">
                <el-table-column
                  prop="key"
                  label="Từ khóa cấm">
                  <template slot-scope="scope">
                    <span class="fw-semibold">{{ scope.row.key }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Tài khoản"
                  align="center"
                  prop="employee">
                  <template slot-scope="scope">
                    <span>{{ scope.row.employee }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Lượt dùng"
                  align="center"
                  prop="total">
                  <template slot-scope="scope">
                    <span>{{ scope.row.total }}</span>
                  </template>
                </el-table-column>
              </el-table>
            <div class="d-flex justify-content-end mt-3" v-if="exportData.length > 0">
              <el-button plain type="primary" size="small" @click="exportToXLSXBadwords" class="d-flex align-items-center">
                <span>Xuất dữ liệu</span>
                <span class="icon-download mx-1" />
              </el-button>
            </div>
              <!--            <div v-if="badWords.length>0" class="d-flex justify-content-end mt-3 pointer text-primary font-size-16"-->
              <!--                 @click="exportBadWord()">Xuất-->
              <!--              dữ liệu-->
              <!--              <div class="icon-download mt-1 mx-1" />-->
              <!--            </div>-->
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import elTableExport from "el-table-export";
import { quickSortDescending, quickSortAscending } from "../../lib/array-utils";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  components: { DateRangePicker },
  name: "EmployeeStatistical",
  data() {
    return {
      selectedTagIds: [],
      types: [
        { name: "Tất cả liên hệ", val: "all" },
        { name: "Cá nhân", val: "personal" },
        { name: "Nhóm", val: "group" },
        { name: "Zalo OA", val: "page" },
      ],
      selectType: "all",
      isLoading: false,
      isReadyRender: false,
      dateRange: {
        startDate: new Date(),
        endDate: new Date(),
      },
      accounts: [],
      selectedEm: [],
      selectedAccount: [],
      employees: [],
      overviewId: "",
      seriesAccount: [],
      seriesAccountAndEmployee: [],
      series_a: [],
      seriesA: [],
      seriesB: [],
      chartOptions_a: {
        labels: [],
        chart: {
          type: "donut",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      series_b: [],
      chartOptions_b: {
        chart: {
          type: "donut",
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      slider: {
        interval: 0,
        total: 0,
        index: 0,
      },
      badWords: [],
      exportData: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      json_fields: {
        "Id hội thoại": "id",
        "Nhân viên": "username",
        "Từ nhạy cảm": "w",
        "Số lần dùng": "total",
      },
      dataFriends: [],
      friendRequestTypeList: [
        { val: "accept", name: "Đồng ý kết bạn", color: "#1A6B44" },
        { val: "reject", name: "Từ chối kết bạn", color: "#CF4547" },
        { val: "undo", name: "Thu hồi lời mời", color: "#CF4547" },
        { val: "send", name: "Gửi kết bạn", color: "#1A6B44" },
        { val: "remove", name: "Xóa bạn", color: "#CF4547" },
        { val: "block", name: "Chặn tin nhắn", color: "#CF4547" },
        { val: "unblock", name: "Bỏ chặn tin nhắn", color: "#1A6B44" },
      ],
    };
  },
  methods: {
    getTagName(tag) {
      if (tag.assign) {
        return tag.name + " (*)";
      }
      return tag.name;
    },
    exportFile() {
      elTableExport(this.$refs.elTable, {
        fileName: "export-message-employee",
        type: "csv",
        withBOM: true,
      })
        .then(() => {
          console.info("ok");
        })
        .catch((err) => {
          console.info(err);
        });
    },
    exportBadWord() {
      elTableExport(this.$refs.badWordTable, {
        fileName: "export-badWord-employee",
        type: "csv",
        withBOM: true,
      })
        .then(() => {
          console.info("ok");
        })
        .catch((err) => {
          console.info(err);
        });
    },

    exportToXLSXSeriesAccount() {
      const data = this.seriesAccount.map(row => ({
        "Tài khoản": row.employee,
        "Hội thoại": row.totalConversation,
        "Đã gửi": row.sent,
        ...this.friendRequestTypeList.reduce((acc, item) => {
          acc[item.name] = row[item.val] || 0;
          return acc;
        }, {})
      }));

      this.exportXLSX(data, "export-message-employee.xlsx", "Báo cáo tài khoản");
    },

    exportToXLSXBadwords() {
      
      const data = this.exportData.map(row => ({
        "Id hội thoại": row.id,
        "Nhân viên": row.username,
        "Từ nhạy cảm": row.w,
        "Số lần dùng": parseInt(row.total, 10) || 0,
      }));

      this.exportXLSX(data, "export-conversation-badWords.xlsx", "Báo cáo hội thoại");
    },

    exportXLSX(data, fileName, sheetName) {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, fileName);
    },

    getAccounts() {
      // this.$http.get("/api/account/getAll").then((resp) => {
        this.accounts = this.app.accounts;
        this.$http.get("/api/employee/getAllUsername").then((val) => {
          this.employees = val.data;
          let filter = this.employees.filter((e) => e.username == this.app.user.swUsername);
          if (filter == null || filter.length == 0) {
            this.employees.push({ username: this.app.user.swUsername, accounts: this.accounts });
          }
          this.fetchStatistic();
        });
      // });
    },
    fetchStatistic() {
      let startTime = this.dateRange.startDate.setHours(0, 0, 0, 0);
      let endTime = this.dateRange.endDate.setHours(23, 59, 59, 999);
      this.overviewId = startTime.toString() + "_" + endTime.toString() + "_" + new Date().getTime();
      this.seriesAccount = [];
      this.seriesAccountAndEmployee = [];

      this.series_a = [];
      this.series_b = [];
      this.badWords = [];
      this.dataFriends = [];
      let emps = [];
      let accountIds = [];
      if (this.selectedAccount.length == 0) {
        this.accounts.forEach((acc) => {
          let fil = accountIds.filter((f) => f == acc.accountId);
          if (fil == null || fil.length == 0) {
            accountIds.push(acc.accountId);
          }
        });
      } else {
        accountIds = this.selectedAccount;
      }
      if (this.selectedEm.length == 0) {
        this.employees.forEach((emp) => {
          emps.push(emp.username);
        });
      } else {
        // let emp = this.employees.filter(e => e.username == this.selectedEm);
        // if (emp != null && emp.length > 0) {
        emps = this.selectedEm;
        // }
      }
      if (accountIds.length > 0 && emps.length > 0) {
        this.isLoading = true;
        this.$http
          .post("/api/statistic/overview", {
            startTime: startTime,
            endTime: endTime,
            statisticType: "employee",
            id: this.overviewId,
            type: this.selectType,
            accountIds: accountIds,
            employees: emps,
            tagIds: this.selectedTagIds,
          })
          .then((res) => {
            this.slider.total = res.data;
            this.slider.index = 0;
          });
      }
    },
    getNameAcc(accountId) {
      let a = this.accounts.filter((p) => p.accountId == accountId)[0];
      return this.getAccountName(a);
    },
    updateSlider() {
      this.slider.index += 1;
      this.slider.interval = ((this.slider.index / this.slider.total) * 100).toFixed(2);
    },
    updateStatistic(data) {
      if (data.id == this.overviewId) {
        this.isLoading = false;
        let f;
        f = this.seriesAccountAndEmployee.find((acc) => acc.newId == data.newId);
        if (!f) {
          this.seriesAccountAndEmployee.push(data);
          this.updateSlider();

          if (this.slider.interval == 100) {
            this.updateSeriesRate();
            this.updateSeriesAccount();
          }
        }
      }
    },

    groupDataFriend(data) {
      let groupData = [];
      data.data.forEach((i) => {
        try {
          const response = JSON.parse(i.response);
          if (response.error_code == 0 || response.error_code == 222) {
            const exist = groupData.find((d) => d.employee == i.swUsername);
            if (exist) {
              if (exist[i.type]) {
                exist[i.type] += 1;
              } else {
                exist[i.type] = 1;
              }
            } else {
              const newData = { employee: i.swUsername };
              newData[i.type] = 1;
              groupData.push(newData);
            }
          }
        } catch (err) {
          console.log(err);
        }
      });

      let dataGroupByUser = JSON.parse(JSON.stringify(this.dataFriends));
      groupData.forEach((i) => {
        const exist = dataGroupByUser.find((d) => d.employee == i.employee);
        if (exist) {
          this.friendRequestTypeList.forEach((type) => {
            exist[type.val] += i[type.val] || 0;
          });
        } else {
          const newData = { employee: i.employee };
          dataGroupByUser.push(newData);
          this.friendRequestTypeList.forEach((type) => {
            newData[type.val] = i[type.val] || 0;
          });
        }
      });
      this.dataFriends = dataGroupByUser;
      this.updateSlider();

      if (this.slider.index == this.slider.total) {
        this.updateSeriesAccount();
        this.updateSeriesRate();
      }
    },
    updateSeriesAccount() {
      let dataGroupByUser = this.dataFriends;
      const newSeriesAccount = JSON.parse(JSON.stringify(this.seriesAccount));
      dataGroupByUser.forEach((d) => {
        let existIdx = newSeriesAccount.findIndex((acc) => acc.employee == d.employee);
        if (existIdx !== -1) {
          newSeriesAccount[existIdx] = {
            ...newSeriesAccount[existIdx],
            ...d,
          };
        } else {
          newSeriesAccount.push({
            totalConversation: 0,
            sent: 0,
            ...d,
          });
        }
      });
      this.seriesAccount = newSeriesAccount;
    },
    updateSeriesRate() {
      this.seriesAccountAndEmployee.forEach((da) => {
        da.items.forEach((item) => {
          let filter = this.seriesAccount.find((acc) => acc.employee == item.employee);
          if (!filter) {
            this.seriesAccount.push({
              totalConversation: item.totalConversation,
              sent: item.sent,
              employee: item.employee,
            });
          } else {
            filter.totalConversation += item.totalConversation;
            filter.sent += item.sent;
          }
          if (item.badWords.length > 0) {
            item.badWords.forEach((k) => {
              let filBad = this.badWords.find((p) => p.key == k && p.employee == this.getEmployeeName(item.employee));
              if (!filBad) {
                this.badWords.push({ key: k, total: 1, employee: this.getEmployeeName(item.employee) });
              } else {
                filBad.total += 1;
              }
            });
          }
          if (item.badList.length > 0) {
            item.badList.forEach((k) => {
              let bw = JSON.parse(k.newId);
              bw.forEach((w) => {
                let filBad = this.exportData.find((p) => p.id == k.id && p.username == k.username && p.w == w);
                if (!filBad) {
                  this.exportData.push({ w: w, total: 1, id: k.id, username: k.username });
                } else {
                  filBad.total += 1;
                }
              });
            });
          }
        });
      });
      this.calculateStatistic();
    },
    getEmployeeName(username) {
      try {
        return username.split("/")[1];
      } catch (_) {
        //
      }
      return username;
    },
    calculateStatistic() {
      this.series_a = [];
      this.series_b = [];
      this.chartOptions_a.labels = [];
      this.seriesAccount = quickSortAscending(this.seriesAccount, "employee");

      if (this.slider.index == this.slider.total) {
        this.updateSeriesAccount(this.dataFriends);
      }

      this.seriesAccount.forEach((acc) => {
        this.series_a.push(acc);
        this.series_b.push(acc);
      });
      setTimeout(() => {
        this.series_a = quickSortDescending(this.series_a, "totalConversation");
        this.series_b = quickSortDescending(this.series_b, "sent");
        const MAX_ITEM = this.series_a.length < 50 ? this.series_a.length : 50;
        const series_a_splice = this.series_a.splice(0, MAX_ITEM);
        const series_b_splice = this.series_b.splice(0, MAX_ITEM);
        this.seriesA = series_a_splice.map((s) => s.totalConversation);
        this.seriesB = series_b_splice.map((s) => s.sent);
        this.setOption(
          series_a_splice.map((s) => s.employee),
          series_b_splice.map((s) => s.employee)
        );
        this.isReadyRender = true;
      }, 500);
    },
    setOption(labelsA, labelsB) {
      this.chartOptions_a = {
        colors: this.getRandomColors(20),
        labels: labelsA,
        chart: {
          type: "donut",
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
              customIcons: [],
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ",",
                headerCategory: "category",
                headerValue: "value",
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString();
                },
              },
              svg: {
                filename: undefined,
              },
              png: {
                filename: undefined,
              },
            },
            autoSelected: "zoom",
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
      this.chartOptions_b = {
        colors: this.getRandomColors(20),
        labels: labelsB,
        chart: {
          type: "donut",
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
              customIcons: [],
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ",",
                headerCategory: "category",
                headerValue: "value",
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString();
                },
              },
              svg: {
                filename: undefined,
              },
              png: {
                filename: undefined,
              },
            },
            autoSelected: "zoom",
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
  },
  beforeDestroy() {
    this.$bus.$off("EmployeeStatistical_event");
    this.$bus.$off("EmployeeStatistical_friendRequest");
  },
  created() {
    this.$bus.$on("EmployeeStatistical_event", (data) => {
      this.updateStatistic(data);
    });
    this.$bus.$on("EmployeeStatistical_friendRequest", (data) => {
      if (data.id == this.overviewId) {
        this.groupDataFriend(data);
      }
    });
    this.getAccounts();
  },
};
</script>

<style scoped>
</style>
